import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'sgt-vigencia-campanha-form-control-radio',
    templateUrl: './vigencia-campanha-form-control-radio.component.html',
    styleUrls: ['./vigencia-campanha-form-control-radio.component.less']
})
export class VigenciaCampanhaFormControlComponent {
    @Input() vigenciaRecorrente: boolean;
    @Output() vigenciaRecorrenteChange =  new EventEmitter<boolean>();
    @Input() required = true;
    @Input() canEdit = true;
    @Input() inputLabel = 'Esta vigência é recorrente?';
    @Input() msgRequiredError = 'É obrigatório informar se a vigência é recorrente ou não';
    @Input() inputHelpText = 'Uma vigência recorrente é aquela que não possui uma data de término definida e que ocorre repetidamente sem prazo determinado';
    @Input() name = 'vigenciaRecorrente';
    @Input() id = 'vigenciaRecorrente';

    /** Ao alterar a flag de vigência recorrente */
    onChange(value: boolean) {
        this.vigenciaRecorrente = value;
        this.vigenciaRecorrenteChange.emit(this.vigenciaRecorrente);
    }
}
